import React, { Component } from "react";
import WatchMeta from "./WatchMeta";
import ViewMeta from "./ViewMeta";
import ViewData from "./ViewData";
import ConfigButton from "../quiz/ConfigButton";

export default class Quiz1 extends Component {
  render() {
    const { search } = this.props.location || {};
    const { history } = this.props;
    return (
      <>
        <div className="row">
          <ConfigButton
            title="난이도 설정"
            pathname={"/quiz1?meta"}
            history={history}
            search={search}
          />
          <ConfigButton
            title="문제 설정"
            pathname={"/quiz1?data"}
            history={history}
            search={search}
          />
        </div>
        {search.includes("meta") && (
          <>
            <WatchMeta />
            <ViewMeta />
          </>
        )}
        {search.includes("data") && (
          <>
            <ViewData />
          </>
        )}
      </>
    );
  }
}
